import { getProjectType } from '../config-utils/projectType';
import { ProjectTypes } from '../styles-utils';

export const STATE_IDENTIFIER = 'state';
export const COUNTY_IDENTIFIER = 'county';
export const USER_MEMBERSHIP = 'user_membership';
export const DEFAULT_COUNTRY = 'GB';
export const DEFAULT_COUNTRY_IDENTIFIER = 'user_addresses_0_country';
export const OTHERFAVORITEPLAYER_IDENTIFIER = 'favoritePlayerOther';
export const OTHEROPTION = 'Other';
export const MENCATEGORY = 'favoriteMenPlayer';
export const WOMENCATEGORY = 'favoriteWomenPlayer';
export const FAVORITEPLAYER = 'favoritePlayer';

export const USER_EMAIL = 'user_email';
export const USER_PERSONAL_REFERRAL_CODE = 'user_campaignFields_referredByCode';

export const COUNTRY_MOBILE_PREFIX_IDENTIFIER =
  'user_countryCodeMobilePhonePrefix';

export const PP_COUNTRY_MOBILE_IDENTIFIER =
  'championshipPlayer_championshipMobileCountryCode';

export const getDefaultCountryIdentifier = () => {
  const projectType = getProjectType();
  switch (projectType) {
    case ProjectTypes.PlayerPortals:
      return PP_COUNTRY_MOBILE_IDENTIFIER;
    case ProjectTypes.SSO:
      return DEFAULT_COUNTRY_IDENTIFIER;
    default:
      return DEFAULT_COUNTRY_IDENTIFIER;
  }
};
